
import Routes from "./routes";
import './style.css';

function App() {
    return (
        <div>
            <Routes />
        </div>
    );
}

export default App;
